<template>
  <v-layout wrap>
    <v-flex xs12 pb-0>
      <v-layout wrap align-center>
        <v-flex xs12 mt-3>
          <h1 class="headline">{{ $t('companyAdd.title') }}</h1>
          <hr />
          <company-form />
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import CompanyForm from '@/components/company/CompanyForm.vue';
import hasPermission from '@/helpers/hasPermission';

export default {
  beforeRouteEnter(to, from, next) {
    if (hasPermission('company_add')) next();
    if (from.name !== 'companies-list') next({ name: 'companies-list' });
  },
  name: 'AddCompanyPage',
  components: {
    CompanyForm,
  },
  data() {
    return {};
  },
  computed: {},
};
</script>

<style lang="scss" scoped></style>
